<script>
import PageNavigationButton from '@/packages/ui/components/Pagination/PageNavigationButton.vue';
import { Icon } from '@/packages/ui/components';

export default {
  name: 'PaginationButtons',
  components: {
    Icon,
    PageNavigationButton,
  },
  props: {
    countItems: {
      type: Number,
      default: 10,
    },
    page: {
      type: Number,
      default: 1,
    },
    totalItems: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    prevPage() {
      return this.page - 1;
    },
    nextPage() {
      return this.page + 1;
    },
    lastPage() {
      return Math.ceil(this.totalItems / this.countItems);
    },
  },
  methods: {
    handleChange(value) {
      this.$emit('change', value);
    },
    handleDecrement() {
      this.$emit('change', this.prevPage);
    },
    handleIncrement() {
      this.$emit('change', this.nextPage);
    },
  },
};
</script>

<template>
  <div class="cxm-PaginationButtons">
    <PageNavigationButton
      v-if="page !== 1"
      @click="handleChange(1)"
    >
      <Icon
        :stop-propagation="false"
        name="ChevronLeftDouble"
        size="16"
      />
    </PageNavigationButton>
    <PageNavigationButton
      v-if="page !== 1"
      @click="handleDecrement()"
    >
      <Icon
        :stop-propagation="false"
        name="ChevronLeft"
        size="12"
      />
    </PageNavigationButton>

    <PageNavigationButton
      v-if="page >= 2"
      label="1"
      @click="handleChange(1)"
    />
    <span v-if="page > 3">⋅⋅⋅</span>

    <PageNavigationButton
      v-if="page > 2"
      :label="prevPage"
      @click="handleDecrement()"
    />
    <PageNavigationButton
      active
      :label="page"
    />
    <PageNavigationButton
      v-if="page < lastPage"
      :label="nextPage"
      @click="handleIncrement()"
    />

    <span v-if="page < lastPage - 1">⋅⋅⋅</span>
    <PageNavigationButton
      v-if="page !== lastPage && page < lastPage - 1"
      :label="lastPage"
      @click="handleChange(lastPage)"
    />
    <PageNavigationButton
      v-if="page !== lastPage"
      @click="handleIncrement()"
    >
      <Icon
        :stop-propagation="false"
        name="ChevronRight"
        size="12"
      />
    </PageNavigationButton>
    <PageNavigationButton
      v-if="page !== lastPage"
      @click="handleChange(lastPage)"
    >
      <Icon
        :stop-propagation="false"
        name="ChevronRightDouble"
        size="16"
      />
    </PageNavigationButton>
  </div>
</template>

<style scoped lang="scss">
.cxm-PaginationButtons {
  align-items: center;
  display: flex;
  gap: var(--track-spacing-sm);
  justify-content: center;
}
</style>
